import React, { useState, useEffect } from "react";
import { css } from "emotion";
import CardInfoFidelityProgramDetails from "../../../shared/create-offer/CardInfoFidelityProgramDetails/CardInfoFidelityProgramDetails";
import Loading from "../../../shared/Loading/Loading";
import { useNewOffer } from "../../context/new-offer";

import { loadingStyle, pageRegistrationData } from "./style";
import BoxCreditCardDetails from "../../../shared/create-offer/BoxCreditCardDetails/BoxCreditCardDetails";
import { ItemCardInfoCreditCard } from "../../../shared/create-offer/ItemsCardInfoFidelityProgramDetails/ItemCardInfoCreditCard";
import LayoutSticky from "../molecules/LayoutSticky";

const RegistrationCreditCard = () => {
	const [state, setState] = useState({
		inputInFocus: ""
	});

	const {
		creditCardData,
		setCreditCardData,
		newOfferTempData,
		setNewOfferTempData
	} = useNewOffer();

	useEffect(() => {
		// Verifica se já há dados em creditCardData
		if (!!Object.keys(creditCardData.data).length) {
			let temp = {
				...state,
				data: {
					...creditCardData.data
				}
			};
			setState(temp);
		}
	}, [creditCardData.data]);

	const setInputInFocus = component => {
		let temp = {
			...state,
			inputInFocus: component
		};

		setState(temp);
	};

	const setData = data => {
		setCreditCardData({
			...creditCardData,
			data: { ...creditCardData.data, ...data }
		});
	};

	const renderCardInfo = () => {
		return <ItemCardInfoCreditCard />;
	};

	const checkData = (box, value) => {
		setNewOfferTempData({
			...newOfferTempData,
			form: {
				...newOfferTempData.form,
				[box]: value
			}
		});
	};

	return creditCardData.isFetching ? (
		<div
			className={css`
				${loadingStyle};
			`}
		>
			<Loading width={120} height={120} />
		</div>
	) : (
		<div
			className={css`
				${pageRegistrationData()}
			`}
		>
			<div className="row">
				<div className="col-xs-9">
					<BoxCreditCardDetails
						checkData={checkData}
						inputInFocus={state.inputInFocus}
						setData={setData}
						setInputInFocus={setInputInFocus}
						creditCardData={creditCardData.data}
					/>
				</div>
				<div className="col-xs-7">
					<LayoutSticky>
						<CardInfoFidelityProgramDetails children={renderCardInfo()} />
					</LayoutSticky>
				</div>
			</div>
		</div>
	);
};

export default RegistrationCreditCard;
